import { UploadFileForm } from './components/UploadScreen';
import './App.css';

function App() {
  return (
    <div className="App">
      <UploadFileForm />
    </div>
  );
}

export default App;
